import { reactMount } from '@/lib/reactMount'
import { useRef } from 'react'
import { Button } from '@/components/Button'

export const twoColumnInfoBlock = ({ dataset, umbraco }) => {
  const umbracoRef = useRef(umbraco || JSON.parse(dataset.umbraco))
  umbraco ||= umbracoRef.current

  const backgroundColor = umbraco.BlockBackground ? `#${umbraco.BlockBackground}` : '#ffffff'
  const mediaLeft = umbraco.MediaLeft || false
  const align = umbraco.Alignment || 'center'

  return (
    <>
      <div
        id={umbraco.AnchorTarget || undefined}
        className='_block-section _textImageBlock-section relative isolate py-10 lg:py-12 md:px-4 lg:px-4'
        style={{ backgroundColor }}
      >
        <div className='flex flex-col md:flex-row w-full max-w-[1248px] mx-auto'>
          <div className={`${mediaLeft ? 'order-2' : 'order-1'} md:w-[60%] lg:w-1/2 px-4 flex flex-col ${align === 'center' ? 'justify-center' : ''} ${align === 'bottom' ? 'justify-end' : ''} ${align === 'top' ? 'justify-start' : ''}`}>
            <div className='_rte' dangerouslySetInnerHTML={{ __html: umbraco.Summary }} />
            {umbraco.Button && (
              <div className='mt-7'>
                <Button
                  size='lg'
                  href={umbraco.Button.Url}
                  target={umbraco.Button.Target || '_self'}
                >
                  {umbraco.Button.Name || 'Learn more'}
                </Button>
              </div>
            )}
          </div>
          <div className={`${mediaLeft ? 'order-1 mb-8 md:mb-0' : 'order-2 mt-8 md:mt-0'} md:w-[40%] lg:w-1/2 flex px-4 justify-end`}>
            <div className={`w-full justify-center flex ${mediaLeft ? 'md:justify-start' : 'md:justify-end'} ${align === 'center' ? 'items-center' : ''} ${align === 'bottom' ? 'items-end' : ''} ${align === 'top' ? 'items-start' : ''}`}>
              <div className='relative w-full md:max-h-[448px] max-w-[448px] md:aspect-[3/2.25] flex justify-center items-center'>
                <img src={umbraco.Media.Url} className='max-w-full max-h-full w-auto h-auto' alt={umbraco.Media.AltText} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

reactMount('twoColumnInfoBlock', twoColumnInfoBlock)
